function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BonaireFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FEDA00",
      fillRule: "evenodd",
      d: "M0 11.2V3h12L0 11.2Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00268D",
      fillRule: "evenodd",
      d: "M0 21h24.007V3L0 21Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      fill: "#fff",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        d: "m7.015 6.75.395.848a3.3 3.3 0 0 1 2.904 3.194l.716.358-.782.391a3.303 3.303 0 0 1-2.807 2.607L7.015 15l-.426-.852a3.303 3.303 0 0 1-2.807-2.607L3 11.15l.716-.358a3.3 3.3 0 0 1 2.877-3.19l.422-.852Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7.015 6.75.395.848a3.3 3.3 0 0 1 2.904 3.194l.716.358-.782.391a3.303 3.303 0 0 1-2.807 2.607L7.015 15l-.426-.852a3.303 3.303 0 0 1-2.807-2.607L3 11.15l.716-.358a3.3 3.3 0 0 1 2.877-3.19l.422-.852Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#212124",
      d: "m7.41 7.598-.453.212.117.252.277.033.06-.497Zm-.395-.848.453-.211-.44-.943-.461.932.448.222Zm3.299 4.042-.5.012.008.3.268.135.224-.447Zm.716.358.224.447.894-.447-.894-.447-.224.447Zm-.782.391-.224-.447-.217.109-.05.238.49.1ZM7.44 14.148l-.064-.496-.264.034-.12.238.448.224ZM7.015 15l-.447.224.447.894.447-.894L7.015 15Zm-.426-.852.447-.224-.119-.238-.264-.034-.064.496ZM3.782 11.54l.49-.1-.049-.238-.217-.11-.224.448ZM3 11.15l-.224-.447-.894.447.894.447L3 11.15Zm.716-.358.224.447.268-.134.008-.3-.5-.013Zm2.877-3.19.063.496.266-.034.119-.24-.448-.222Zm1.27-.215-.395-.848-.906.422.395.849.906-.423Zm2.95 3.393A3.8 3.8 0 0 0 7.47 7.102l-.118.993a2.8 2.8 0 0 1 2.463 2.71l1-.025Zm.44-.077-.715-.358-.448.894.716.358.448-.894Zm-.782 1.285.783-.39-.448-.895-.782.39.447.895Zm-2.966 2.656a3.803 3.803 0 0 0 3.233-3.002l-.98-.201a2.802 2.802 0 0 1-2.38 2.21l.127.993Zm-.511-.72-.426.852.894.448.426-.853-.894-.447Zm.468.852-.426-.852-.894.447.426.853.894-.448Zm-4.17-3.134a3.803 3.803 0 0 0 3.233 3.002l.128-.992a2.803 2.803 0 0 1-2.38-2.211l-.98.2Zm-.516-.045.783.391.447-.894-.782-.391-.448.894Zm.716-1.252-.716.358.448.894.716-.358-.448-.894Zm3.038-3.24a3.8 3.8 0 0 0-3.314 3.675l1 .024a2.8 2.8 0 0 1 2.44-2.706l-.126-.992Zm.037-.577-.422.852.896.444.422-.852-.896-.444Z",
      mask: "url(#b)"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F00A17",
      fillRule: "evenodd",
      d: "m7.032 9.225-.487.817h-.96l.479.858-.479.823h.96l.487.84.494-.84h.951L8.01 10.9l.467-.858h-.95l-.495-.817Z",
      clipRule: "evenodd"
    })]
  })]
}));
//# sourceMappingURL=Bonaire.js.map